import React from 'react';
import { CheckIcon, GiftIcon, CreditCardIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
const includes = ['Ebook completo com +100 páginas', 'Passo a passo detalhado de produção', 'Guia de fornecedores confiáveis testados', 'Estratégias de vendas e marketing'];
const bonuses = ['BÔNUS: Lista Secreta de Fornecedores', 'BÔNUS: Máquina de Lucro', 'BÔNUS: Checklist de Lançamento', 'BÔNUS: Script de Vendas Irresistível'];
export function Offer() {
  return <section id="oferta" className="py-24 lg:py-32 bg-gradient-to-b from-brand-blush/30 to-white relative overflow-hidden" data-id="element-157">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-158">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-8 items-center" data-id="element-159">
          {/* Left Column: Benefits */}
          <div className="w-full lg:w-1/2" data-id="element-160">
            <FadeIn direction="right" data-id="element-161">
              <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-brown mb-6" data-id="element-162">
                Invista no seu futuro hoje
              </h2>
              <p className="text-xl text-brand-brown/70 mb-10" data-id="element-163">
                Tudo que você precisa para começar seu negócio de velas
                aromáticas em um único lugar.
              </p>

              <div className="space-y-8" data-id="element-164">
                <div data-id="element-165">
                  <h3 className="font-bold text-brand-brown uppercase tracking-wider text-sm mb-4" data-id="element-166">
                    O que você vai receber:
                  </h3>
                  <ul className="space-y-4" data-id="element-167">
                    {includes.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-168">
                        <div className="bg-brand-rose/10 p-1 rounded-full text-brand-rose shrink-0 mt-0.5" data-id="element-169">
                          <CheckIcon className="w-4 h-4" data-id="element-170" />
                        </div>
                        <span className="text-brand-brown font-medium" data-id="element-171">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>

                <div className="bg-brand-gold/10 border border-brand-gold/30 rounded-xl p-6" data-id="element-172">
                  <h3 className="font-bold text-brand-gold uppercase tracking-wider text-sm mb-4 flex items-center gap-2" data-id="element-173">
                    <GiftIcon className="w-4 h-4" data-id="element-174" /> Bônus Exclusivos
                  </h3>
                  <ul className="space-y-4" data-id="element-175">
                    {bonuses.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-176">
                        <div className="bg-brand-gold p-1 rounded-full text-white shrink-0 mt-0.5" data-id="element-177">
                          <CheckIcon className="w-4 h-4" data-id="element-178" />
                        </div>
                        <span className="text-brand-brown font-medium" data-id="element-179">
                          {item}
                        </span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </FadeIn>
          </div>

          {/* Right Column: Pricing Card */}
          <div className="w-full lg:w-1/2 flex justify-center lg:justify-end" data-id="element-180">
            <FadeIn direction="left" delay={0.2} className="w-full max-w-md" data-id="element-181">
              <div className="bg-white rounded-[2rem] shadow-2xl shadow-brand-brown/10 border border-brand-blush overflow-hidden relative" data-id="element-182">
                {/* Top Accent Bar */}
                <div className="h-4 w-full bg-gradient-to-r from-brand-rose via-[#B85D7F] to-brand-gold" data-id="element-183"></div>

                <div className="p-8 md:p-10 text-center" data-id="element-184">
                  <div className="inline-block bg-brand-rose/10 text-brand-rose font-bold px-4 py-1.5 rounded-full text-sm mb-6" data-id="element-185">
                    Acesso Imediato
                  </div>

                  <p className="text-brand-brown/50 line-through text-xl font-medium mb-2" data-id="element-186">
                    De R$ 97,00
                  </p>
                  <div className="flex flex-col items-center justify-center mb-8" data-id="element-187">
                    <span className="text-brand-brown text-lg font-medium mb-1" data-id="element-188">
                      Por apenas
                    </span>
                    <span className="font-serif text-6xl font-bold text-brand-rose leading-none" data-id="element-189">
                      R$ 67,00
                    </span>
                    <span className="text-brand-brown/60 text-sm mt-2" data-id="element-190">
                      Pagamento único, sem mensalidades
                    </span>
                  </div>

                  <motion.a href="https://pay.hotmart.com/example" target="_blank" rel="noopener noreferrer" whileHover={{
                  scale: 1.03
                }} whileTap={{
                  scale: 0.97
                }} className="block w-full bg-brand-rose text-white py-5 rounded-full font-bold text-xl shadow-lg shadow-brand-rose/30 hover:bg-brand-rose/90 transition-colors mb-6" data-id="element-191">
                    Quero Começar Agora
                  </motion.a>

                  <div className="flex flex-col items-center gap-3" data-id="element-192">
                    <p className="text-brand-rose font-bold text-sm flex items-center justify-center gap-2" data-id="element-193">
                      <span className="relative flex h-3 w-3" data-id="element-194">
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-rose opacity-75" data-id="element-195"></span>
                        <span className="relative inline-flex rounded-full h-3 w-3 bg-brand-rose" data-id="element-196"></span>
                      </span>
                      Oferta por tempo limitado
                    </p>

                    <div className="flex items-center gap-2 text-brand-brown/50 text-sm mt-2" data-id="element-197">
                      <CreditCardIcon className="w-4 h-4" data-id="element-198" />
                      <span data-id="element-199">PIX, Cartão ou Boleto</span>
                    </div>
                  </div>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}